import { AppState } from "../../reducers";
import { ImportPageState } from "./reducer";

export const importPageSelector = (state: AppState): ImportPageState => {
  return state.importPage;
};
